(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arbib-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const wrapper = document.getElementById('arbibAboutWrapper');
    if (!wrapper) return;

    const isDesignMode = window.Shopify && Shopify.designMode;
    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
    const sections = wrapper.querySelectorAll('.arbib-about__section');
    const totalSections = sections.length;
    let current = 0;
    let locked = false;
    const LOCK_MS = 1200;

    // About page wants the header transparent with white text the whole
    // way down — every section sits over a dark image with a dark overlay.
    document.body.classList.add('arbib-hero-dark');
    if (window.arbibHeader && typeof window.arbibHeader.setSolid === 'function') {
      window.arbibHeader.setSolid(false);
    }

    if (!isMobile() && !isDesignMode) {
      document.documentElement.classList.add('arbib-about-snap');
    }

    function lock() { locked = true; setTimeout(() => { locked = false; }, LOCK_MS); }

    function goTo(i) {
      if (i < 0 || i >= totalSections) return;
      current = i;
      if (!isMobile() && !isDesignMode) {
        wrapper.style.transform = 'translateY(' + (-i * 100) + 'vh)';
      }
    }

    if (!isMobile() && !isDesignMode) {
      window.addEventListener('wheel', function (e) {
        if (document.body.classList.contains('arbib-legal-open')) return;
        if (locked) { e.preventDefault(); return; }
        if (Math.abs(e.deltaY) < 5) return;
        e.preventDefault();
        if (e.deltaY > 0 && current < totalSections - 1) { lock(); goTo(current + 1); }
        else if (e.deltaY < 0 && current > 0) { lock(); goTo(current - 1); }
      }, { passive: false });

      let touchY = 0;
      window.addEventListener('touchstart', (e) => { touchY = e.touches[0].clientY; }, { passive: true });
      window.addEventListener('touchend', function (e) {
        if (locked) return;
        const diff = touchY - e.changedTouches[0].clientY;
        if (Math.abs(diff) < 50) return;
        if (diff > 0 && current < totalSections - 1) { lock(); goTo(current + 1); }
        else if (diff < 0 && current > 0) { lock(); goTo(current - 1); }
      });

      window.addEventListener('keydown', function (e) {
        if (locked) return;
        if ((e.key === 'ArrowDown' || e.key === 'PageDown') && current < totalSections - 1) {
          lock(); goTo(current + 1); e.preventDefault();
        } else if ((e.key === 'ArrowUp' || e.key === 'PageUp') && current > 0) {
          lock(); goTo(current - 1); e.preventDefault();
        }
      });
    }

    // ===== Reveals + year animations via IntersectionObserver =====
    const obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('.arbib-about__rv').forEach(function (el) {
          el.classList.add('is-visible');
        });
        const yearEl = entry.target.querySelector('[data-count-to], [data-scramble-to]');
        if (yearEl) animateYear(yearEl);
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -20% 0px' });
    sections.forEach((s) => obs.observe(s));
    // Force-reveal the first section on load (hero copy)
    sections[0].querySelectorAll('.arbib-about__rv').forEach((el) => el.classList.add('is-visible'));

    // ===== Two knobs control the whole feel =====
    // DURATION: total time per number. Same for every number, so they all
    //           finish at the exact same moment regardless of the year range.
    // CADENCE:  how fast the digits flicker (the "switch speed"). LOWER = faster
    //           churn. This is what makes 1990→2000 look as alive as 0→1990,
    //           because the flicker rate no longer depends on numeric distance.
    const YEAR_DURATION = 900;
    const YEAR_CADENCE = 45;

    function animateYear(el) {
      if (el.dataset.animated) return;
      el.dataset.animated = '1';
      if (el.dataset.scrambleTo) return scrambleLetters(el, el.dataset.scrambleTo, YEAR_DURATION);
      const target = parseInt(el.dataset.countTo, 10);
      const suffix = el.dataset.suffix || '';
      scrambleDigits(el, String(target), suffix, YEAR_DURATION, YEAR_CADENCE);
    }

    function scrambleDigits(el, finalText, suffix, duration, cadence) {
      const chars = finalText.split('');
      const startTime = performance.now();
      // Lock digits left-to-right across the duration — same settle pattern
      // as the "Today" letter scramble, so the whole sequence feels unified.
      const lockTimes = chars.map((_, i) => (i + 1) / chars.length);
      let lastChange = 0;
      let randoms = chars.map(() => Math.floor(Math.random() * 10));
      function tick(now) {
        const elapsed = now - startTime;
        const t = Math.min(elapsed / duration, 1);
        if (now - lastChange >= cadence) {
          randoms = chars.map(() => Math.floor(Math.random() * 10));
          lastChange = now;
        }
        let display = '';
        for (let i = 0; i < chars.length; i++) {
          display += (t >= lockTimes[i]) ? chars[i] : randoms[i];
        }
        el.textContent = display + suffix;
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = finalText + suffix;
      }
      requestAnimationFrame(tick);
    }

    function scrambleLetters(el, finalText, duration) {
      const chars = finalText.split('');
      const pool = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      const startTime = performance.now();
      const lockTimes = chars.map((_, i) => (i + 1) / chars.length);
      const letterChangeMs = 95;
      let lastChange = 0;
      let randoms = chars.map(() => pool[Math.floor(Math.random() * pool.length)]);
      function tick(now) {
        const elapsed = now - startTime;
        const t = Math.min(elapsed / duration, 1);
        if (now - lastChange >= letterChangeMs) {
          randoms = chars.map(() => pool[Math.floor(Math.random() * pool.length)]);
          lastChange = now;
        }
        let display = '';
        for (let i = 0; i < chars.length; i++) {
          display += (t >= lockTimes[i]) ? chars[i] : randoms[i];
        }
        el.textContent = display;
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = finalText;
      }
      requestAnimationFrame(tick);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arbib-application-modal"]) return;
  try {
    
  (function () {
    const modal = document.getElementById('arbibApplicationModal');
    if (!modal) return;

    const form = document.getElementById('arbibApplicationForm');
    const submitUrl = form.dataset.submitUrl;
    const totalSteps = parseInt(form.dataset.totalSteps, 10) || 1;
    const requiredMsg = form.dataset.requiredMsg || 'This field is required';
    const emailMsg = form.dataset.emailMsg || 'Please enter a valid email';

    const bars = modal.querySelectorAll('.arbib-app__bar');
    const stepCurrent = document.getElementById('arbibAppStepCurrent');
    const steps = modal.querySelectorAll('.arbib-app__step');
    const btnBack = document.getElementById('arbibAppBack');
    const btnNext = document.getElementById('arbibAppNext');
    const submitError = document.getElementById('arbibAppSubmitError');
    const closeBtn = document.getElementById('arbibAppClose');

    const nextLabel = btnNext.dataset.nextLabel || btnNext.textContent;
    const submitLabel = btnNext.dataset.submitLabel || nextLabel;

    let currentStep = 1;
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    modal.querySelectorAll('.arbib-app__options').forEach(function (group) {
      const mode = group.dataset.select;
      group.addEventListener('click', function (e) {
        const pill = e.target.closest('.arbib-app__pill');
        if (!pill) return;
        if (mode === 'single') {
          group.querySelectorAll('.arbib-app__pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
        } else {
          pill.classList.toggle('is-selected');
        }
        clearError(group.closest('.arbib-app__field'));
      });
    });

    modal.querySelectorAll('.arbib-app__yn-btns').forEach(function (group) {
      group.addEventListener('click', function (e) {
        const btn = e.target.closest('.arbib-app__yn-btn');
        if (!btn) return;
        group.querySelectorAll('.arbib-app__yn-btn').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        clearError(group.closest('.arbib-app__field'));
      });
    });

    modal.querySelectorAll('.arbib-app__accredited').forEach(function (group) {
      group.addEventListener('change', function (e) {
        const cb = e.target;
        if (!cb.matches('input.arbib-app__cbinput')) return;
        const row = cb.closest('.arbib-app__cbrow');
        row.classList.toggle('is-checked', cb.checked);
        const isDisq = cb.value === 'none';
        if (cb.checked) {
          if (isDisq) {
            group.querySelectorAll('input.arbib-app__cbinput').forEach(function (other) {
              if (other !== cb) {
                other.checked = false;
                other.closest('.arbib-app__cbrow').classList.remove('is-checked');
              }
            });
          } else {
            const none = group.querySelector('input.arbib-app__cbinput[value="none"]');
            if (none && none.checked) {
              none.checked = false;
              none.closest('.arbib-app__cbrow').classList.remove('is-checked');
            }
          }
        }
        const field = group.closest('.arbib-app__field');
        const warning = field.querySelector('[data-warning]');
        if (warning) {
          const noneChecked = group.querySelector('input.arbib-app__cbinput[value="none"]:checked');
          warning.hidden = !noneChecked;
        }
        clearError(field);
      });
    });

    modal.querySelectorAll('.arbib-app__agree-input').forEach(function (cb) {
      cb.addEventListener('change', function () {
        const row = cb.closest('.arbib-app__agree');
        row.classList.toggle('is-checked', cb.checked);
        clearError(cb.closest('.arbib-app__field'));
      });
    });

    modal.querySelectorAll('.arbib-app__sig-input').forEach(function (input) {
      input.addEventListener('input', function () {
        const box = input.closest('.arbib-app__sig-box');
        const printSpan = box.querySelector('[data-sig-print]');
        if (printSpan) printSpan.textContent = input.value.trim().toUpperCase() || '—';
        clearError(input.closest('.arbib-app__field'));
      });
    });

    function refreshSignatureDate() {
      const formatted = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
      modal.querySelectorAll('[data-sig-date]').forEach(function (span) {
        span.textContent = formatted;
      });
    }

    function showStep(n) {
      submitError.hidden = true;
      submitError.textContent = '';
      modal.classList.toggle('arbib-app--step-9', n === 9);
      steps.forEach(function (s) {
        const targetMatch = (n === 'success' && s.dataset.step === 'success') ||
                            String(n) === s.dataset.step;
        s.classList.toggle('is-active', targetMatch);
      });
      if (n === 'success') {
        modal.classList.add('is-success');
        return;
      }
      currentStep = n;
      bars.forEach(function (bar, i) {
        const idx = i + 1;
        bar.classList.remove('is-current', 'is-done');
        if (idx < n) bar.classList.add('is-done');
        if (idx === n) bar.classList.add('is-current');
      });
      if (stepCurrent) stepCurrent.textContent = n;
      btnBack.classList.toggle('is-shown', n > 1);
      btnNext.textContent = (n === totalSteps) ? submitLabel : nextLabel;
      refreshSignatureDate();
      const body = modal.querySelector('.arbib-app__body');
      if (body) body.scrollTop = 0;
      modal.scrollTop = 0;
    }

    function clearError(field) {
      if (!field) return;
      const err = field.querySelector('.arbib-app__error');
      if (err) { err.classList.remove('is-shown'); err.textContent = ''; }
      field.querySelectorAll('.arbib-app__input, .arbib-app__textarea, .arbib-app__select, .arbib-app__sig-input').forEach(function (el) {
        el.classList.remove('is-error');
      });
    }

    function showFieldError(field, message) {
      const err = field.querySelector('.arbib-app__error');
      if (err) {
        err.textContent = message || requiredMsg;
        err.classList.add('is-shown');
      }
      field.querySelectorAll('.arbib-app__input, .arbib-app__textarea, .arbib-app__select, .arbib-app__sig-input').forEach(function (el) {
        el.classList.add('is-error');
      });
    }

    function validateStep(n) {
      const stepEl = modal.querySelector('.arbib-app__step[data-step="' + n + '"]');
      if (!stepEl) return true;
      let ok = true;
      stepEl.querySelectorAll('.arbib-app__field').forEach(function (field) {
        const required = field.dataset.questionRequired === 'true';
        const type = field.dataset.questionType;
        clearError(field);
        if (type === 'question_notice') return;
        if (!required) {
          if (type === 'question_email') {
            const input = field.querySelector('input');
            const v = input ? input.value.trim() : '';
            if (v && !emailRe.test(v)) { showFieldError(field, emailMsg); ok = false; }
          }
          return;
        }
        if (type === 'question_multiple_choice' || type === 'question_dropdown') {
          let hasValue = false;
          if (type === 'question_dropdown') {
            const sel = field.querySelector('select');
            hasValue = sel && sel.value !== '';
          } else {
            hasValue = !!field.querySelector('.arbib-app__pill.is-selected');
          }
          if (!hasValue) { showFieldError(field); ok = false; }
        } else if (type === 'question_yes_no') {
          if (!field.querySelector('.arbib-app__yn-btn.is-selected')) { showFieldError(field); ok = false; }
        } else if (type === 'question_checkboxes') {
          if (!field.querySelector('.arbib-app__pill.is-selected')) { showFieldError(field); ok = false; }
        } else if (type === 'question_accredited') {
          if (!field.querySelector('input.arbib-app__cbinput:checked')) { showFieldError(field, 'Please select an option'); ok = false; }
        } else if (type === 'question_acknowledgment') {
          const cb = field.querySelector('.arbib-app__agree-input');
          if (!cb || !cb.checked) { showFieldError(field, 'Please acknowledge to continue'); ok = false; }
        } else if (type === 'question_signature') {
          const input = field.querySelector('.arbib-app__sig-input');
          const v = input ? input.value.trim() : '';
          if (!v) { showFieldError(field, 'Type your full legal name to sign'); ok = false; }
        } else {
          const input = field.querySelector('input, textarea');
          const value = input ? input.value.trim() : '';
          if (!value) { showFieldError(field); ok = false; }
          else if (type === 'question_email' && !emailRe.test(value)) { showFieldError(field, emailMsg); ok = false; }
        }
      });
      return ok;
    }

    function collectData() {
      const answers = [];
      let disqualified = false;
      modal.querySelectorAll('.arbib-app__field').forEach(function (field) {
        const id = field.dataset.questionId;
        const type = field.dataset.questionType;
        const label = field.dataset.questionLabel;
        if (type === 'question_notice') return;
        let value = null;
        if (type === 'question_multiple_choice') {
          const sel = field.querySelector('.arbib-app__pill.is-selected');
          value = sel ? sel.dataset.value : null;
        } else if (type === 'question_yes_no') {
          const sel = field.querySelector('.arbib-app__yn-btn.is-selected');
          value = sel ? sel.dataset.value : null;
        } else if (type === 'question_checkboxes') {
          value = Array.from(field.querySelectorAll('.arbib-app__pill.is-selected')).map(function (p) { return p.dataset.value; });
        } else if (type === 'question_dropdown') {
          const sel = field.querySelector('select');
          value = sel ? sel.value : null;
        } else if (type === 'question_accredited') {
          const checked = Array.from(field.querySelectorAll('input.arbib-app__cbinput:checked'));
          const rows = checked.map(function (cb) {
            const row = cb.closest('.arbib-app__cbrow');
            return row ? row.dataset.value : cb.value;
          });
          if (checked.some(function (cb) { return cb.value === 'none'; })) { disqualified = true; }
          value = rows.join('; ') || null;
        } else if (type === 'question_acknowledgment') {
          const cb = field.querySelector('.arbib-app__agree-input');
          value = (cb && cb.checked) ? 'Agreed' : 'Not agreed';
        } else if (type === 'question_signature') {
          const input = field.querySelector('.arbib-app__sig-input');
          const typed = input ? input.value.trim() : '';
          if (typed) {
            const now = new Date();
            const dateStr = now.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
            value = typed + ' — signed on ' + dateStr;
          }
        } else {
          const input = field.querySelector('input, textarea');
          value = input ? input.value.trim() : null;
        }
        answers.push({ id: id, label: label, type: type, value: value });
      });
      return { answers: answers, disqualified: disqualified, submitted_at: new Date().toISOString() };
    }

    btnNext.addEventListener('click', function () {
      if (!validateStep(currentStep)) return;
      if (currentStep === totalSteps) { submit(); }
      else { showStep(currentStep + 1); }
    });

    btnBack.addEventListener('click', function () {
      if (currentStep > 1) showStep(currentStep - 1);
    });

    form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="number"]').forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        if (inp.classList.contains('arbib-app__sig-input')) return;
        if (e.key === 'Enter') { e.preventDefault(); btnNext.click(); }
      });
    });

    function submit() {
      const data = collectData();
      submitError.hidden = true;
      submitError.textContent = '';
      btnNext.disabled = true;
      btnNext.setAttribute('aria-busy', 'true');
      fetch(submitUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data),
      })
        .then(function (r) {
          return r.json().then(function (json) {
            return { ok: r.ok, status: r.status, json: json };
          }).catch(function () { return { ok: r.ok, status: r.status, json: {} }; });
        })
        .then(function (res) {
          if (res.ok && res.json && res.json.success) {
            showStep('success');
          } else {
            const message = (res.json && res.json.error) || 'Something went wrong. Please try again or email arbibdevelopment@gmail.com directly.';
            submitError.textContent = message;
            submitError.hidden = false;
          }
        })
        .catch(function () {
          submitError.textContent = 'Could not connect. Please try again or email arbibdevelopment@gmail.com directly.';
          submitError.hidden = false;
        })
        .finally(function () {
          btnNext.disabled = false;
          btnNext.removeAttribute('aria-busy');
        });
    }

    var mqMobileModal = window.matchMedia('(max-width: 989px)');
    function open() {
      // Mobile: an ancestor transform breaks position:fixed and drops the modal
      // into page flow at the bottom. Re-parent to <body> so it overlays the viewport.
      if (mqMobileModal.matches && modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.hidden = false;
      document.body.classList.add('arbib-app-open');
      if (mqMobileModal.matches) pinToViewport();
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      refreshSignatureDate();
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.classList.remove('arbib-app-open');
      window.removeEventListener('resize', pinToViewport);
      window.removeEventListener('scroll', pinToViewport);
      setTimeout(function () {
        modal.hidden = true;
        PIN_PROPS.forEach(function (p) { modal.style.removeProperty(p); });
      }, 400);
    }

    // Mobile: something in the theme overrides the modal's position:fixed, so
    // it renders in page flow under the footer. Force overlay styles inline
    // with !important (nothing in a stylesheet can beat that), then measure
    // and correct any offset so it covers exactly the visible screen.
    var PIN_PROPS = ['position', 'top', 'left', 'right', 'bottom', 'width', 'height', 'margin', 'z-index', 'overflow-y', 'display', 'transform'];
    function pinToViewport() {
      var s = modal.style;
      s.setProperty('position', 'fixed', 'important');
      s.setProperty('display', 'block', 'important');
      s.setProperty('left', '0', 'important');
      s.setProperty('right', '0', 'important');
      s.setProperty('bottom', 'auto', 'important');
      s.setProperty('width', '100%', 'important');
      s.setProperty('height', window.innerHeight + 'px', 'important');
      s.setProperty('margin', '0', 'important');
      s.setProperty('transform', 'none', 'important');
      s.setProperty('z-index', '2147483000', 'important');
      s.setProperty('overflow-y', 'auto', 'important');
      s.setProperty('top', '0px', 'important');
      var offset = modal.getBoundingClientRect().top;
      if (Math.abs(offset) > 1) s.setProperty('top', (-offset) + 'px', 'important');
      window.removeEventListener('resize', pinToViewport);
      window.removeEventListener('scroll', pinToViewport);
      window.addEventListener('resize', pinToViewport);
      window.addEventListener('scroll', pinToViewport, { passive: true });
    }

    window.arbibApplicationModal = { open: open, close: close };

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.open-application-modal');
      if (trigger) { e.preventDefault(); open(); }
    });
    // Mobile menu drawer: catch "Application" link, close drawer, open modal
    function closeMenuDrawer() {
      var hd = document.querySelector('header-drawer');
      if (hd && typeof hd.close === 'function') { try { hd.close(); } catch (err) {} }
      document.querySelectorAll('header details[open], header-drawer details[open], .menu-drawer-container[open]').forEach(function (d) { d.removeAttribute('open'); });
      document.querySelectorAll('dialog[open]').forEach(function (d) { if (d !== modal && typeof d.close === 'function') d.close(); });
      document.body.classList.remove('overflow-hidden', 'menu-open', 'overflow-hidden-mobile');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.style.overflow = '';
    }
    var APP_HREF = /(#apply|#application|open-application|\/pages\/apply)/i;
    var APP_TEXT = /^\s*(apply|apply now|application|applications|investor application)\s*$/i;
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a, button');
      if (!link) return;
      if (!link.closest('header-drawer, .menu-drawer, .menu-drawer-container, [id^="Details-menu-drawer"], [class*="drawer"]')) return;
      var href = link.getAttribute('href') || '';
      if (!link.classList.contains('open-application-modal') && !APP_HREF.test(href) && !APP_TEXT.test(link.textContent)) return;
      e.preventDefault();
      e.stopPropagation();
      closeMenuDrawer();
      setTimeout(open, 50);
    }, true);

    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden && modal.classList.contains('is-open')) close();
    });

    showStep(1);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arbib-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!document.querySelector('arbib-contact')) return;

    // Contact page wants the shared header in its solid (cream) state always —
    // the contact layout has no full-bleed dark hero to sit transparent over.
    if (window.arbibHeader && typeof window.arbibHeader.setSolid === 'function') {
      window.arbibHeader.setSolid(true);
    }

    const singleOverlay = document.getElementById('arbibContactSingleOverlay');
    const portfolioOverlay = document.getElementById('arbibContactPortfolioOverlay');
    const contentContact = document.getElementById('arbibContactContent');
    const contentApplication = document.getElementById('arbibApplicationContent');
    const bgB4 = document.getElementById('arbibContactB4');
    const bgB5 = document.getElementById('arbibContactB5');
    const bgB5Text = document.getElementById('arbibContactB5Text');
    const picContainer = document.getElementById('arbibContactPicContainer');

    let currentState = 'contact';
    let transitioning = false;

    function updateNav(newState) {
      document.querySelectorAll('.arbib-contact__menu-item').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.state === newState);
      });
    }

    function swipeText(newState) {
      const showing = newState === 'contact' ? contentContact : contentApplication;
      const hiding = newState === 'contact' ? contentApplication : contentContact;
      if (showing.dataset.pos === 'visible') return;
      if (showing.dataset.pos !== 'above') {
        showing.dataset.pos = 'above';
        // eslint-disable-next-line no-unused-expressions
        showing.offsetWidth;
      }
      setTimeout(function () { showing.dataset.pos = 'visible'; }, 20);
      hiding.dataset.pos = 'below';
      setTimeout(function () { hiding.dataset.pos = 'above'; }, 1500);
    }

    function resetElement(el, removeClasses, addClasses) {
      el.style.transition = 'none';
      removeClasses.forEach(function (cls) { el.classList.remove(cls); });
      addClasses.forEach(function (cls) { el.classList.add(cls); });
      // eslint-disable-next-line no-unused-expressions
      el.offsetWidth;
      el.style.transition = '';
    }

    function setFooter(newState) {
      if (newState === 'application') {
        resetElement(picContainer, ['is-slid-left', 'is-visible'], []);
        requestAnimationFrame(function () {
          bgB4.classList.add('is-hidden');
          bgB5.classList.add('is-expanded');
          bgB5.classList.add('is-slid-out-left');
          bgB5Text.classList.add('is-slid-out-left');
          picContainer.classList.add('is-visible');
        });
      } else {
        resetElement(bgB4, ['is-hidden'], ['is-from-right']);
        resetElement(bgB5, ['is-expanded', 'is-slid-out-left'], ['is-from-right']);
        resetElement(bgB5Text, ['is-slid-out-left'], ['is-from-right']);
        requestAnimationFrame(function () {
          picContainer.classList.add('is-slid-left');
          bgB4.classList.remove('is-from-right');
          bgB5.classList.remove('is-from-right');
          bgB5Text.classList.remove('is-from-right');
        });
      }
    }

    function switchState(newState) {
      if (newState === currentState || transitioning) return;
      transitioning = true;
      updateNav(newState);
      setFooter(newState);

      if (newState === 'application') {
        setTimeout(function () {
          swipeText(newState);
          singleOverlay.classList.add('is-hidden');
          // eslint-disable-next-line no-unused-expressions
          portfolioOverlay.offsetWidth;
          portfolioOverlay.classList.add('is-in');
        }, 600);
      } else {
        swipeText(newState);
        portfolioOverlay.classList.remove('is-in');
        setTimeout(function () { singleOverlay.classList.remove('is-hidden'); }, 450);
      }

      currentState = newState;
      setTimeout(function () { transitioning = false; }, 2500);
    }

    document.querySelectorAll('.arbib-contact__menu-item').forEach(function (btn) {
      btn.addEventListener('click', function () { switchState(btn.dataset.state); });
    });

    document.addEventListener('keydown', function (e) {
      const order = ['contact', 'application'];
      const idx = order.indexOf(currentState);
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        switchState(order[(idx + 1) % order.length]);
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        switchState(order[(idx - 1 + order.length) % order.length]);
      }
    });

    function triggerLoad() {
      document.body.classList.add('arbib-contact-loaded');
      setTimeout(function () { contentContact.dataset.pos = 'visible'; }, 500);
    }
    if (document.readyState === 'complete') setTimeout(triggerLoad, 80);
    else window.addEventListener('load', function () { setTimeout(triggerLoad, 80); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arbib-header"]) return;
  try {
    
  class ArbibHeader extends HTMLElement {
    constructor() {
      super();
      this._forced = null;
      this._threshold = 80;
      this._onScroll = this._onScroll.bind(this);
    }
    connectedCallback() {
      window.arbibHeader = this;
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      if (window.arbibHeader === this) delete window.arbibHeader;
    }
    _onScroll() {
      if (this._forced !== null) return;
      this._apply(window.scrollY > this._threshold);
    }
    _apply(solid) {
      this.dataset.state = solid ? 'solid' : 'transparent';
    }
    setSolid(value) {
      this._forced = value;
      if (value === null) this._onScroll();
      else this._apply(Boolean(value));
    }
  }
  if (!customElements.get('arbib-header')) {
    customElements.define('arbib-header', ArbibHeader);
  }

  (function () {
    const mq = window.matchMedia('(max-width: 900px)');
    const burger = document.getElementById('arbibBurger');
    const drawer = document.getElementById('arbibDrawer');
    const cta = document.querySelector('.arbib-header__cta');

    if (cta) {
      const fullLabel = cta.textContent.trim();
      function applyLabel() { cta.textContent = mq.matches ? 'Portal' : fullLabel; }
      applyLabel();
      mq.addEventListener('change', applyLabel);
    }

    if (burger && drawer) {
      function closeDrawer() {
        burger.classList.remove('is-open');
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      }
      burger.addEventListener('click', function (e) {
        e.stopPropagation();
        const open = drawer.classList.toggle('is-open');
        burger.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      drawer.querySelectorAll('.arbib-header__drawer-link').forEach(function (link) {
        link.addEventListener('click', function () { setTimeout(closeDrawer, 50); });
      });
      document.addEventListener('click', function (e) {
        if (!drawer.contains(e.target) && e.target !== burger && !burger.contains(e.target)) closeDrawer();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arbib-homepage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[arbib-home] section script loaded', new Date().toISOString());
    const root = document.getElementById('arbibHome');
    if (!root) { console.warn('[arbib-home] #arbibHome not found — section JS bailing'); return; }

    // Skip the state machine entirely in the theme editor so admins can
    // scroll through all content while editing settings.
    const isDesignMode = window.Shopify && Shopify.designMode;
    if (isDesignMode) { console.log('[arbib-home] design mode — JS bailing'); return; }

    // On mobile, the whole desktop scroll-machine (pointermove tracking,
    // hover binding, diagnostics) is skipped — it thrashes layout and janks
    // native scroll. The mobile hero (image swap + Before/After taps) runs
    // in its own lightweight block at the very bottom of this file.
    if (window.matchMedia('(max-width: 768px)').matches) { console.log('[arbib-home] mobile — desktop scroll-machine skipped'); return; }

    const wrapper = document.getElementById('arbibFpWrapper');
    const panels = root.querySelectorAll('.arbib-home__panel');
    const dots = root.querySelectorAll('.arbib-home__panel-dot');
    const prevBtn = document.getElementById('arbibPrevBtn');
    const nextBtn = document.getElementById('arbibNextBtn');
    const counter = document.getElementById('arbibPanelCurrent');
    const footerEl = document.getElementById('arbibEmbeddedFooter');
    const navDotsEl = document.getElementById('arbibPanelNav');
    const navArrowsEl = root.querySelector('.arbib-home__panel-arrows');

    let currentPage = 0; // 0 = hero, 1 = panels
    let currentPanel = 0;
    const totalPanels = panels.length;
    let locked = false;
    const LOCK_MS = 1100;

    function lock() { locked = true; setTimeout(() => { locked = false; }, LOCK_MS); }

    // Find the panel-0 scroll container that has consumable scroll room.
    // Desktop: the text column (.arbib-home__story-right) is the scroller.
    // Tablet:  the whole story-grid (photo + text) is the scroller — the
    //          offer-row is a sibling of story-grid and stays pinned.
    function getPanel0Scroller() {
      const panel = root.querySelector('.arbib-home__panel[data-panel="0"]');
      if (!panel) return null;
      const desktopScroller = panel.querySelector('.arbib-home__story-right');
      if (desktopScroller && desktopScroller.scrollHeight > desktopScroller.clientHeight + 1) {
        return desktopScroller;
      }
      const tabletScroller = panel.querySelector('.arbib-home__story-grid');
      if (tabletScroller && tabletScroller.scrollHeight > tabletScroller.clientHeight + 1) {
        return tabletScroller;
      }
      return null;
    }

    function setHeader(solid) {
      if (window.arbibHeader && typeof window.arbibHeader.setSolid === 'function') {
        window.arbibHeader.setSolid(solid);
      }
    }

    function setPage(p) {
      currentPage = p;
      wrapper.style.transform = 'translateY(' + (-p * 100) + 'vh)';
      setHeader(p === 1);
      if (p === 0) footerEl.classList.remove('is-visible');
    }

    function updatePanelUI() {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === currentPanel));
      if (counter) counter.textContent = currentPanel + 1;
      prevBtn.classList.toggle('is-disabled', currentPanel === 0);
      nextBtn.classList.toggle('is-disabled', currentPanel === totalPanels - 1);
      footerEl.classList.toggle('is-visible', currentPanel === totalPanels - 1);
      // Hide the side dots + bottom arrow rail on the last panel only — they
      // obstruct the drone video on the CTA panel.
      const onLastPanel = currentPanel === totalPanels - 1;
      if (navDotsEl) navDotsEl.classList.toggle('is-hidden', onLastPanel);
      if (navArrowsEl) navArrowsEl.classList.toggle('is-hidden', onLastPanel);
    }

    function showPanel(target) {
      if (target === currentPanel) return;
      if (target < 0 || target >= totalPanels) return;
      const goingDown = target > currentPanel;

      panels.forEach((p, i) => {
        p.classList.remove('is-active', 'is-above', 'is-below');
        if (i === target) {
          p.style.transition = 'none';
          p.style.transform = goingDown ? 'translateY(100%)' : 'translateY(-35%)';
          p.style.opacity = '0';
          // Force reflow so the position-without-transition sticks before
          // we let CSS take over for the animation.
          // eslint-disable-next-line no-unused-expressions
          p.offsetHeight;
          p.style.transition = '';
          requestAnimationFrame(() => {
            p.classList.add('is-active');
            p.style.transform = '';
            p.style.opacity = '';
          });
        } else if (i === currentPanel) {
          p.classList.add(goingDown ? 'is-above' : 'is-below');
          p.style.transform = '';
          p.style.opacity = '';
        } else if (i < target) {
          p.classList.add('is-above');
          p.style.transform = '';
          p.style.opacity = '';
        } else {
          p.classList.add('is-below');
          p.style.transform = '';
          p.style.opacity = '';
        }
      });

      currentPanel = target;
      updatePanelUI();
    }

    // ===== Wheel =====
    const isMobileView = window.matchMedia('(max-width: 768px)').matches;
    window.addEventListener('wheel', function (e) {
      if (isMobileView) return;
      if (document.body.classList.contains('arbib-legal-open')) return;

      // Delegate wheel to the story text column when on panel 0. When the
      // scroller reaches a boundary, fall through to the normal panel-nav
      // handler below so the next wheel tick advances/retreats a panel.
      if (currentPage === 1 && currentPanel === 0) {
        const scroller = getPanel0Scroller();
        if (scroller) {
          const maxScroll = scroller.scrollHeight - scroller.clientHeight;
          const down = e.deltaY > 0;
          const canConsume = (down && scroller.scrollTop < maxScroll - 1) ||
                             (!down && scroller.scrollTop > 0);
          if (canConsume) {
            e.preventDefault();
            scroller.scrollTop += e.deltaY * 0.4;
            return;
          }
        }
      }

      if (locked) { e.preventDefault(); return; }
      if (Math.abs(e.deltaY) < 5) return;
      const down = e.deltaY > 0;

      if (currentPage === 0) {
        if (down) { e.preventDefault(); lock(); setPage(1); }
      } else {
        e.preventDefault();
        if (down) {
          if (currentPanel < totalPanels - 1) { lock(); showPanel(currentPanel + 1); }
        } else {
          if (currentPanel > 0) { lock(); showPanel(currentPanel - 1); }
          else { lock(); setPage(0); }
        }
      }
    }, { passive: false });

    // ===== Touch =====
    let touchY = 0;
    window.addEventListener('touchstart', function (e) { touchY = e.touches[0].clientY; }, { passive: true });
    window.addEventListener('touchend', function (e) {
      if (isMobileView) return;
      if (locked) return;
      const diff = touchY - e.changedTouches[0].clientY;
      if (Math.abs(diff) < 50) return;
      const down = diff > 0;

      // If the story column already consumed the swipe via native touch
      // scroll, don't ALSO advance the panel.
      if (currentPage === 1 && currentPanel === 0) {
        const scroller = getPanel0Scroller();
        if (scroller) {
          const maxScroll = scroller.scrollHeight - scroller.clientHeight;
          const canConsume = (down && scroller.scrollTop < maxScroll - 1) ||
                             (!down && scroller.scrollTop > 0);
          if (canConsume) return;
        }
      }

      if (currentPage === 0) {
        if (down) { lock(); setPage(1); }
      } else {
        if (down) {
          if (currentPanel < totalPanels - 1) { lock(); showPanel(currentPanel + 1); }
        } else {
          if (currentPanel > 0) { lock(); showPanel(currentPanel - 1); }
          else { lock(); setPage(0); }
        }
      }
    });

    // ===== Keyboard =====
    window.addEventListener('keydown', function (e) {
      if (locked) return;
      const isDown = e.key === 'ArrowDown' || e.key === 'PageDown';
      const isUp = e.key === 'ArrowUp' || e.key === 'PageUp';
      if (!isDown && !isUp) return;
      if (currentPage === 0) {
        if (isDown) { lock(); setPage(1); e.preventDefault(); }
      } else {
        if (isDown && currentPanel < totalPanels - 1) { lock(); showPanel(currentPanel + 1); e.preventDefault(); }
        else if (isUp && currentPanel > 0) { lock(); showPanel(currentPanel - 1); e.preventDefault(); }
        else if (isUp && currentPanel === 0) { lock(); setPage(0); e.preventDefault(); }
      }
    });

    // ===== Buttons & dots =====
    prevBtn.addEventListener('click', function () {
      if (locked) return;
      if (currentPanel > 0) { lock(); showPanel(currentPanel - 1); }
      else { lock(); setPage(0); }
    });
    nextBtn.addEventListener('click', function () {
      if (locked) return;
      if (currentPanel < totalPanels - 1) { lock(); showPanel(currentPanel + 1); }
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        if (locked) return;
        const t = parseInt(d.dataset.goto, 10);
        if (t !== currentPanel) { lock(); showPanel(t); }
      });
    });

    // ===== Jump-to-panel buttons (e.g. hero "Get Started" → panel 3) =====
    document.querySelectorAll('[data-arbib-go-panel]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        if (locked) return;
        const t = parseInt(el.dataset.arbibGoPanel, 10);
        lock();
        if (currentPage === 0) {
          setPage(1);
          setTimeout(function () { showPanel(t); }, 120);
        } else {
          showPanel(t);
        }
      });
    });

    // ===== Direct-bind any .open-application-modal element in this section
    // as a safety net. The application modal section already delegates from
    // document, but if its IIFE failed to load (e.g. JS error elsewhere),
    // this still catches the click and surfaces it in console.
    function openApplicationModal(source) {
      console.log('[arbib-home] openApplicationModal called from', source, {
        hasApi: !!(window.arbibApplicationModal && window.arbibApplicationModal.open),
      });
      if (window.arbibApplicationModal && typeof window.arbibApplicationModal.open === 'function') {
        window.arbibApplicationModal.open();
        return true;
      }
      console.warn('[arbib-home] Application modal not initialized — check that arbib-application-modal section rendered.');
      return false;
    }

    // Direct-bind every .open-application-modal element in this section.
    const ctaTriggers = root.querySelectorAll('.open-application-modal');
    console.log('[arbib-home] found', ctaTriggers.length, 'open-application-modal triggers in section');
    ctaTriggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openApplicationModal('direct-bind:' + (el.dataset.arbibAppTrigger || el.className));
      });
    });

    // Capture-phase document handler — fires BEFORE any element-level bubble
    // handler can stopPropagation(), and catches dynamically-added triggers.
    // This is the bulletproof path: if the click reaches the document at all,
    // this opens the modal.
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.open-application-modal');
      if (!trigger) return;
      e.preventDefault();
      openApplicationModal('capture-doc');
    }, true);

    // ===== JS-bound hover for offer cards and process steps =====
    // CSS :hover fires inconsistently in our layout. mouseenter doesn't
    // bubble — so each card/step gets clean per-element enter/leave events
    // independent of stacking, child elements, or CSS quirks.
    const offerCards = root.querySelectorAll('.arbib-home__offer-card');
    const stepItems = root.querySelectorAll('.arbib-home__step-item');
    console.log('[arbib-home] hover binding:', offerCards.length, 'offer cards,', stepItems.length, 'step items');
    function bindHover(el, idx, label) {
      el.addEventListener('mouseenter', function () {
        el.classList.add('is-hovered');
        console.log('[arbib-home] mouseenter →', label, idx, '— classes now:', el.classList.toString());
      });
      el.addEventListener('mouseleave', function () {
        el.classList.remove('is-hovered');
      });
    }
    offerCards.forEach(function (el, i) { bindHover(el, i, 'offer-card'); });
    stepItems.forEach(function (el, i) { bindHover(el, i, 'step-item'); });

    // ===== Overlay diagnostic =====
    // For each clickable surface, ask the browser "what element is actually
    // at your center?" via elementFromPoint. If the answer is not the
    // surface itself, that's the overlay intercepting events.
    function describeEl(el) {
      if (!el) return 'null';
      // el.className is SVGAnimatedString on SVG elements — use getAttribute instead.
      const cls = (el.getAttribute && el.getAttribute('class')) || '';
      const firstCls = cls.split(/\s+/)[0] || '';
      return el.tagName.toLowerCase() + (el.id ? '#' + el.id : '') + (firstCls ? '.' + firstCls : '') + (cls ? ' [classes=' + cls + ']' : '');
    }

    function diagnoseTarget(label, el) {
      if (!el) { console.log('[arbib-home][diag]', label, '— not found'); return; }
      const r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) {
        console.log('[arbib-home][diag]', label, '— zero-size rect (off-screen / display:none?)', r);
        return;
      }
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;
      const hit = document.elementFromPoint(cx, cy);
      const isSelf = hit === el;
      const isDescendant = hit && el.contains(hit);
      const mark = isSelf ? 'OK ✓' : isDescendant ? 'OK (descendant) ✓' : 'BLOCKED ✗';
      console.log('[arbib-home][diag]', label, mark, 'at (' + Math.round(cx) + ',' + Math.round(cy) + ') — hit:', describeEl(hit));
      if (!isSelf && !isDescendant && hit) {
        // Walk up from hit until we find a positioned ancestor — that's the overlay's container
        let cursor = hit;
        let depth = 0;
        while (cursor && depth < 8) {
          const cs = getComputedStyle(cursor);
          if (cs.position !== 'static' || cs.zIndex !== 'auto') {
            console.log('[arbib-home][diag]   ↳ positioned ancestor:', describeEl(cursor), 'position:', cs.position, 'z-index:', cs.zIndex, 'pointer-events:', cs.pointerEvents);
          }
          cursor = cursor.parentElement;
          depth++;
        }
      }
    }

    window.arbibDiagnose = function () {
      console.log('=== arbib overlay diagnostic — currentPanel:', currentPanel, 'currentPage:', currentPage, '===');
      offerCards.forEach(function (el, i) { diagnoseTarget('offer-card ' + i, el); });
      stepItems.forEach(function (el, i) { diagnoseTarget('step-item ' + i, el); });
      diagnoseTarget('panel-3-cta', root.querySelector('.open-application-modal'));
    };

    // Auto-run diagnostic after each panel/page change so user gets fresh
    // results without having to call anything. elementFromPoint only works
    // on elements in the visible viewport, so the diagnostic must run AFTER
    // navigation transitions complete.
    const _origShowPanel = showPanel;
    showPanel = function (target) {
      _origShowPanel(target);
      setTimeout(window.arbibDiagnose, 1200);
    };
    const _origSetPage = setPage;
    setPage = function (p) {
      _origSetPage(p);
      setTimeout(window.arbibDiagnose, 1200);
    };

    // ===== Hero hairline slider =====
    // Tracking strategy: bind pointermove to `document` and gate on whether
    // the cursor is within the hero section's bounding box AND we're still
    // on page 0 (the hero, not the panels). This lets the slider keep
    // following the cursor when it's over the buttons, the pill, the header,
    // or anywhere else inside the hero zone — pointer-events on those
    // elements stay normal (clickable) since we don't rely on them
    // forwarding the event.
    const sLine = document.getElementById('arbibHeroLine');
    const afterLayer = document.getElementById('arbibHeroAfter');
    const beforeLayer = root.querySelector('.arbib-home__hero-before');
    const heroSection = document.getElementById('arbibHero');
    let revealDone = false;
    let isOverHero = false;

    // ===== Mobile: swap to portrait images + tappable Before/After =====
    const mqMobile = window.matchMedia('(max-width: 768px)');
    function applyMobileHero() {
      if (mqMobile.matches) {
        [beforeLayer, afterLayer].forEach(function (el) {
          if (el && el.dataset.mobileImg) el.style.backgroundImage = "url('" + el.dataset.mobileImg + "')";
        });
      } else {
        // Restore desktop images (re-read from the original inline value isn't stored, so reload-safe approach: only swap on mobile)
      }
    }
    applyMobileHero();
    mqMobile.addEventListener('change', applyMobileHero);

    const tagBefore = root.querySelector('.arbib-home__hero-tag--before');
    const tagAfter = root.querySelector('.arbib-home__hero-tag--after');
    function slideTo(pct) {
      sLine.style.transition = 'left 1s cubic-bezier(0.45,0,0.15,1)';
      afterLayer.style.transition = 'clip-path 1s cubic-bezier(0.45,0,0.15,1)';
      sLine.style.left = pct + '%';
      afterLayer.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    }
    if (tagBefore && tagAfter) {
      tagBefore.addEventListener('click', function () {
        if (!mqMobile.matches) return;
        slideTo(0);
        tagBefore.classList.add('is-active');
        tagAfter.classList.remove('is-active');
      });
      tagAfter.addEventListener('click', function () {
        if (!mqMobile.matches) return;
        slideTo(100);
        tagAfter.classList.add('is-active');
        tagBefore.classList.remove('is-active');
      });
    }

    afterLayer.addEventListener('animationend', function () {
      revealDone = true;
      sLine.style.animation = 'none';
      afterLayer.style.animation = 'none';
      sLine.style.left = '100%';
      afterLayer.style.clipPath = 'inset(0 0% 0 0)';
      if (mqMobile.matches && tagAfter) tagAfter.classList.add('is-active');
    });

    function setSliderPos(p) {
      p = Math.max(0, Math.min(100, p));
      sLine.style.left = p + '%';
      afterLayer.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
    }

    function returnToRest() {
      // 0.8s smooth return — only fires on actually leaving the hero zone.
      sLine.style.transition = 'left 0.8s cubic-bezier(0.16,1,0.3,1)';
      afterLayer.style.transition = 'clip-path 0.8s cubic-bezier(0.16,1,0.3,1)';
      sLine.style.left = '100%';
      afterLayer.style.clipPath = 'inset(0 0% 0 0)';
    }

    document.addEventListener('pointermove', function (e) {
      if (!revealDone || e.pointerType === 'touch') return;
      // Stop responding once user has scrolled past the hero into the panels.
      if (currentPage !== 0) {
        if (isOverHero) { isOverHero = false; returnToRest(); }
        return;
      }
      const r = heroSection.getBoundingClientRect();
      const within = e.clientX >= r.left && e.clientX <= r.right
                  && e.clientY >= r.top  && e.clientY <= r.bottom;
      if (within) {
        if (!isOverHero) {
          isOverHero = true;
          // Kill transitions so motion is instant cursor-tracking, no lag.
          sLine.style.transition = 'none';
          afterLayer.style.transition = 'none';
        }
        const p = ((e.clientX - r.left) / r.width) * 100;
        setSliderPos(p);
      } else if (isOverHero) {
        isOverHero = false;
        returnToRest();
      }
    });

    // If the pointer leaves the window entirely (browser chrome / off-screen),
    // also return to rest. pointerleave on document doesn't fire reliably
    // across browsers, but mouseleave on documentElement does.
    document.documentElement.addEventListener('mouseleave', function () {
      if (!revealDone) return;
      if (isOverHero) { isOverHero = false; returnToRest(); }
    });

    // ===== Init =====
    setHeader(false);
    updatePanelUI();
  })();

  // ===== Mobile-only: hero image swap + Before/After taps =====
  // Runs independently of the desktop scroll-machine (which bails on mobile).
  (function () {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    // Mobile "Get Started" → smooth scroll to the Apply panel
    document.querySelectorAll('[data-arbib-go-panel]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector('.arbib-home__panel[data-panel="' + el.dataset.arbibGoPanel + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var sLine = document.getElementById('arbibHeroLine');
    var afterLayer = document.getElementById('arbibHeroAfter');
    var beforeLayer = document.querySelector('.arbib-home__hero-before');
    var tagBefore = document.querySelector('.arbib-home__hero-tag--before');
    var tagAfter = document.querySelector('.arbib-home__hero-tag--after');
    if (!sLine || !afterLayer || !tagBefore || !tagAfter) return;

    // Swap to portrait images
    [beforeLayer, afterLayer].forEach(function (el) {
      if (el && el.dataset.mobileImg) el.style.backgroundImage = "url('" + el.dataset.mobileImg + "')";
    });

    // Default to "after" once the intro animation finishes
    afterLayer.addEventListener('animationend', function () {
      sLine.style.animation = 'none';
      afterLayer.style.animation = 'none';
      sLine.style.left = '100%';
      afterLayer.style.clipPath = 'inset(0 0% 0 0)';
      tagAfter.classList.add('is-active');
    });

    function slideTo(pct) {
      sLine.style.animation = 'none';
      afterLayer.style.animation = 'none';
      sLine.style.transition = 'left 1s cubic-bezier(0.45,0,0.15,1)';
      afterLayer.style.transition = 'clip-path 1s cubic-bezier(0.45,0,0.15,1)';
      sLine.style.left = pct + '%';
      afterLayer.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    }
    function showBefore(e) { if (e) { e.preventDefault(); e.stopPropagation(); } slideTo(0); tagBefore.classList.add('is-active'); tagAfter.classList.remove('is-active'); }
    function showAfter(e)  { if (e) { e.preventDefault(); e.stopPropagation(); } slideTo(100); tagAfter.classList.add('is-active'); tagBefore.classList.remove('is-active'); }

    tagBefore.addEventListener('click', showBefore);
    tagAfter.addEventListener('click', showAfter);
    tagBefore.addEventListener('touchend', showBefore);
    tagAfter.addEventListener('touchend', showAfter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arbib-legal-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const modal = document.getElementById('arbibLegalModal');
    if (!modal) return;
    const body = document.getElementById('arbibLegalBody');
    const closeBtn = document.getElementById('arbibLegalClose');
    const cache = {};

    var savedOverflow = '';
    function open(url) {
      // Escape any locked/transformed parent (e.g. the homepage wrapper) by
      // reparenting the modal directly under <body>.
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.classList.add('arbib-legal-open');
      modal.scrollTop = 0;
      loadPage(url);
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.classList.remove('arbib-legal-open');
      setTimeout(function () { modal.hidden = true; }, 400);
    }
    function loadPage(url) {
      if (cache[url]) { body.innerHTML = cache[url]; return; }
      body.innerHTML = '<div class="arbib-legal__loading">Loading…</div>';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('.rte') || doc.querySelector('main .page-content') || doc.querySelector('main');
          const out = content ? content.innerHTML : '<p>Unable to load. Please try again.</p>';
          cache[url] = out;
          body.innerHTML = out;
        })
        .catch(function () {
          body.innerHTML = '<p>Unable to load this page. Please visit it directly.</p>';
        });
    }

    window.arbibLegalModal = { open: open, close: close };

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-arbib-legal]');
      if (!trigger) return;
      e.preventDefault();
      const url = trigger.getAttribute('href') || trigger.dataset.arbibLegal;
      open(url);
    });
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden && modal.classList.contains('is-open')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arbib-portfolio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const stage = document.getElementById('arbibPortfolioStage');
    if (!stage) return;

    const isDesignMode = window.Shopify && Shopify.designMode;

    document.body.classList.add('arbib-hero-dark');
    if (window.arbibHeader && typeof window.arbibHeader.setSolid === 'function') {
      window.arbibHeader.setSolid(false);
    }

    const layer1 = stage.querySelector('.arbib-portfolio__layer--1');
    const layer2 = stage.querySelector('.arbib-portfolio__layer--2');
    const video1 = document.getElementById('arbibVideo1');
    const video2 = document.getElementById('arbibVideo2');
    const navDots = stage.querySelectorAll('.arbib-portfolio__nav-dot');

    let projectsData = { projects: {} };
    try {
      projectsData = JSON.parse(document.getElementById('arbibProjectsData').textContent);
    } catch (e) {
      // no-op
    }

    // ===== Layer state machine =====
    let currentLayer = 1;

    function goToLayer(n) {
      if (n !== 1 && n !== 2) return;
      if (n === currentLayer) return;
      currentLayer = n;

      if (n === 2) {
        if (layer2) layer2.classList.add('is-shown');
        if (video2) {
          try { video2.currentTime = 0; } catch (e) {}
          const p = video2.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      } else {
        if (layer2) layer2.classList.remove('is-shown');
        if (video1) {
          try { video1.currentTime = 0; } catch (e) {}
          const p = video1.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      }

      navDots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', (i + 1) === currentLayer);
      });
    }

    if (video1) {
      video1.addEventListener('ended', function () { goToLayer(2); });
      video1.addEventListener('loadedmetadata', function () {
        if (isFinite(video1.duration) && video1.duration > 0) {
          setTimeout(function () { goToLayer(2); }, (video1.duration * 1000) + 200);
        }
      });
    }

    navDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const target = parseInt(dot.dataset.goto, 10);
        goToLayer(target);
      });
    });

    document.addEventListener('keydown', function (e) {
      const lbOpen = document.querySelector('.arbib-portfolio__lightbox.is-open');
      const modalOpen = document.querySelector('.arbib-portfolio__modal.is-open');
      if (lbOpen || modalOpen) return;
      if (e.key === 'ArrowRight') { goToLayer(2); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { goToLayer(1); e.preventDefault(); }
    });

    if (isDesignMode) {
      setTimeout(function () { goToLayer(2); }, 800);
    }

    // ===== Header color switch =====
    function updateHeaderState() {
      if (!(window.arbibHeader && typeof window.arbibHeader.setSolid === 'function')) return;
      const stageHeight = stage.offsetHeight;
      const vh = window.innerHeight;
      const pastStage = window.scrollY > stageHeight - vh * 0.5;
      window.arbibHeader.setSolid(pastStage);
      document.body.classList.toggle('arbib-hero-dark', !pastStage);
    }
    let ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      requestAnimationFrame(function () { updateHeaderState(); ticking = false; });
      ticking = true;
    }, { passive: true });
    window.addEventListener('resize', updateHeaderState);
    updateHeaderState();

    // ===== Modal open/close =====
    function openModal(type) {
      const modal = document.getElementById('arbibModal-' + type);
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    }
    function closeModal() {
      document.querySelectorAll('.arbib-portfolio__modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
      const lbOpen = document.querySelector('.arbib-portfolio__lightbox.is-open');
      if (!lbOpen) document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-arbib-open-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(btn.dataset.arbibOpenModal); });
    });
    document.querySelectorAll('[data-arbib-close-modal]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    document.querySelectorAll('.arbib-portfolio__modal').forEach(function (m) {
      m.addEventListener('click', function (e) { if (e.target === m) closeModal(); });
    });

    stage.querySelectorAll('.arbib-portfolio__layer').forEach(function (layer) {
      layer.addEventListener('click', function (e) {
        if (e.target.closest('.arbib-portfolio__cta')) return;
        if (e.target.closest('.arbib-portfolio__nav')) return;
        openModal('portfolio');
      });
    });

    // ===== Lightbox =====
    const lbEl = document.getElementById('arbibLightbox');
    const lbImage = document.getElementById('arbibLbImage');
    const lbTitle = document.getElementById('arbibLbTitle');
    const lbMeta = document.getElementById('arbibLbMeta');
    const lbCur = document.getElementById('arbibLbCurrent');
    const lbTot = document.getElementById('arbibLbTotal');
    const lbPrev = document.getElementById('arbibLbPrev');
    const lbNext = document.getElementById('arbibLbNext');
    const lbThumbs = document.getElementById('arbibLbThumbs');
    const lbClose = document.getElementById('arbibLbClose');

    let lbProject = null;
    let lbIdx = 0;

    function openLightbox(projectId) {
      const raw = projectsData.projects[projectId];
      if (!raw) return;

      let photos = (raw.photos && raw.photos.length > 0) ? raw.photos : [];
      if (photos.length === 0 && raw.cover) {
        photos = [{ url: raw.cover }];
      }
      if (photos.length === 0) {
        console.info('[arbib-portfolio] No photos for project', projectId, '— add photos to the product in Shopify Admin.');
        return;
      }

      lbProject = { title: raw.title, meta: raw.meta, photos: photos };
      lbIdx = 0;
      lbTitle.textContent = lbProject.title || '';
      lbMeta.textContent = lbProject.meta || '';
      lbTot.textContent = lbProject.photos.length;

      lbThumbs.innerHTML = lbProject.photos.map(function (photo, i) {
        return '<div class="arbib-portfolio__lb-thumb" data-idx="' + i + '" style="background-image:url(\'' + photo.url + '\')"></div>';
      }).join('');
      lbThumbs.querySelectorAll('.arbib-portfolio__lb-thumb').forEach(function (t, i) {
        t.addEventListener('click', function () { setLbPhoto(i); });
      });

      setLbPhoto(0);
      lbEl.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function setLbPhoto(idx) {
      if (!lbProject) return;
      const total = lbProject.photos.length;
      idx = Math.max(0, Math.min(total - 1, idx));
      lbIdx = idx;

      lbImage.classList.remove('is-shown');
      lbImage.onload = function () { lbImage.classList.add('is-shown'); };
      lbImage.src = lbProject.photos[idx].url;

      lbCur.textContent = idx + 1;
      lbPrev.classList.toggle('is-disabled', idx === 0);
      lbNext.classList.toggle('is-disabled', idx === total - 1);

      const thumbs = lbThumbs.querySelectorAll('.arbib-portfolio__lb-thumb');
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      if (thumbs[idx]) thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function closeLightbox() {
      lbEl.classList.remove('is-open');
      const stillModal = document.querySelector('.arbib-portfolio__modal.is-open');
      if (!stillModal) document.body.style.overflow = '';
      lbProject = null;
    }

    document.querySelectorAll('[data-arbib-project-block]').forEach(function (card) {
      card.addEventListener('click', function () {
        openLightbox(card.dataset.arbibProjectBlock);
      });
    });

    lbPrev.addEventListener('click', function () { setLbPhoto(lbIdx - 1); });
    lbNext.addEventListener('click', function () { setLbPhoto(lbIdx + 1); });
    lbClose.addEventListener('click', closeLightbox);
    lbEl.addEventListener('click', function (e) { if (e.target === lbEl) closeLightbox(); });

    document.addEventListener('keydown', function (e) {
      if (lbEl.classList.contains('is-open')) {
        if (e.key === 'Escape') { closeLightbox(); e.stopImmediatePropagation(); }
        else if (e.key === 'ArrowLeft') { setLbPhoto(lbIdx - 1); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { setLbPhoto(lbIdx + 1); e.preventDefault(); }
      } else if (e.key === 'Escape') {
        closeModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
